<div class="d-flex flex-column shape-info-window">
 <textarea rows="4" class="textarea-to-replace-js"
           [formControl]="annotation" placeholder="Create annotation"
           maxlength="{{MAX_LENGTH}}" (focus)="focusHandler()" (blur)="blurHandler()"></textarea>
  <span *ngIf="isFocused" class="chars-left">Characters left: {{charactersLeft}}</span>
  <div *ngIf="isFocused" class="d-flex btn-group control-group">
    <button class="btn d-flex white-button justify-content-center" (click)="deleteAnnotation.emit()">
      <i class="fa fa-trash-o" aria-hidden="true"></i>
      <span>Delete</span>
    </button>
  </div>
</div>
